import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "events-details my-4" };
const _hoisted_2 = { class: "row g-4" };
const _hoisted_3 = { class: "col-12 col-lg-7" };
const _hoisted_4 = { class: "lead" };
const _hoisted_5 = { class: "event-info" };
const _hoisted_6 = { class: "info-item mb-3" };
const _hoisted_7 = { class: "mb-2" };
const _hoisted_8 = { class: "mb-2" };
const _hoisted_9 = { class: "mb-0" };
const _hoisted_10 = { class: "info-item mb-3" };
const _hoisted_11 = { class: "mb-2" };
const _hoisted_12 = { class: "mb-2" };
const _hoisted_13 = { class: "mb-0" };
const _hoisted_14 = { class: "info-item" };
const _hoisted_15 = { class: "mb-0" };
const _hoisted_16 = { class: "col-12 col-lg-5" };
const _hoisted_17 = {
    class: "card p-4 mb-3",
    style: { "background": "var(--bg-secondary)" }
};
const _hoisted_18 = { class: "date-info" };
const _hoisted_19 = { class: "mb-2" };
const _hoisted_20 = { class: "text-primary" };
const _hoisted_21 = { class: "text-primary" };
const _hoisted_22 = { class: "card p-4 mb-3" };
const _hoisted_23 = { class: "mb-2" };
const _hoisted_24 = { class: "mb-0 text-muted" };
const _hoisted_25 = { class: "card p-4" };
const _hoisted_26 = { class: "d-flex align-items-center mb-3" };
const _hoisted_27 = { class: "d-flex align-items-center mb-3" };
const _hoisted_28 = { class: "d-flex align-items-center mb-3" };
const _hoisted_29 = { class: "d-flex align-items-center" };
import { computed } from 'vue';
// Props para recibir el evento
export default /*@__PURE__*/ _defineComponent({
    __name: 'EventsDetails',
    props: {
        event: {}
    },
    setup(__props) {
        const props = __props;
        // Computed properties para mostrar los datos reales del evento
        const eventDescription = computed(() => {
            return props.event?.description || 'Descripción no disponible';
        });
        const eventType = computed(() => {
            const type = props.event?.event_type || 'evento';
            return type.charAt(0).toUpperCase() + type.slice(1);
        });
        const eventPrice = computed(() => {
            const price = props.event?.price;
            if (!price || price === '0.00') {
                return 'Gratuito';
            }
            return `$${price} BOB`;
        });
        const isRecurring = computed(() => {
            return props.event?.is_recurring ? 'Sí' : 'No';
        });
        const eventLocation = computed(() => {
            return (props.event?.place?.name ||
                props.event?.address ||
                props.event?.department?.name ||
                'Ubicación no disponible');
        });
        const eventAddress = computed(() => {
            return (props.event?.place?.address ||
                props.event?.address ||
                'Dirección no disponible');
        });
        const eventHours = computed(() => {
            return props.event?.place?.opening_hours || 'Horarios no disponibles';
        });
        const eventContact = computed(() => {
            return props.event?.place?.contact_info || 'Contacto no disponible';
        });
        const startDate = computed(() => {
            if (!props.event?.start_date)
                return 'Fecha no disponible';
            const date = new Date(props.event.start_date);
            return date.toLocaleDateString('es-ES', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        });
        const endDate = computed(() => {
            if (!props.event?.end_date)
                return 'Fecha no disponible';
            const date = new Date(props.event.end_date);
            return date.toLocaleDateString('es-ES', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "visually-hidden" }, "Descripción del evento", -1)),
                        _createElementVNode("p", _hoisted_4, _toDisplayString(eventDescription.value), 1),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "h6 mb-2" }, [
                                    _createElementVNode("i", { class: "fas fa-info-circle me-2" }),
                                    _createTextVNode("Información del Evento ")
                                ], -1)),
                                _createElementVNode("p", _hoisted_7, [
                                    _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Tipo:", -1)),
                                    _createTextVNode(" " + _toDisplayString(eventType.value), 1)
                                ]),
                                _createElementVNode("p", _hoisted_8, [
                                    _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Precio:", -1)),
                                    _createTextVNode(" " + _toDisplayString(eventPrice.value), 1)
                                ]),
                                _createElementVNode("p", _hoisted_9, [
                                    _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Recurrente:", -1)),
                                    _createTextVNode(" " + _toDisplayString(isRecurring.value), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "h6 mb-2" }, [
                                    _createElementVNode("i", { class: "fas fa-map-marker-alt me-2" }),
                                    _createTextVNode("Ubicación ")
                                ], -1)),
                                _createElementVNode("p", _hoisted_11, [
                                    _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Lugar:", -1)),
                                    _createTextVNode(" " + _toDisplayString(eventLocation.value), 1)
                                ]),
                                _createElementVNode("p", _hoisted_12, [
                                    _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Dirección:", -1)),
                                    _createTextVNode(" " + _toDisplayString(eventAddress.value), 1)
                                ]),
                                _createElementVNode("p", _hoisted_13, [
                                    _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Horarios:", -1)),
                                    _createTextVNode(" " + _toDisplayString(eventHours.value), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                                _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "h6 mb-2" }, [
                                    _createElementVNode("i", { class: "fas fa-phone me-2" }),
                                    _createTextVNode("Contacto ")
                                ], -1)),
                                _createElementVNode("p", _hoisted_15, [
                                    _cache[8] || (_cache[8] = _createElementVNode("strong", null, "Teléfono:", -1)),
                                    _createTextVNode(" " + _toDisplayString(eventContact.value), 1)
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                            _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "h5 mb-3" }, [
                                _createElementVNode("i", { class: "fas fa-calendar-alt me-2" }),
                                _createTextVNode("Fechas del Evento ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("p", _hoisted_19, [
                                    _createElementVNode("span", _hoisted_20, _toDisplayString(startDate.value), 1),
                                    _cache[11] || (_cache[11] = _createTextVNode(" - ", -1)),
                                    _createElementVNode("span", _hoisted_21, _toDisplayString(endDate.value), 1)
                                ]),
                                _cache[12] || (_cache[12] = _createElementVNode("p", { class: "mb-0" }, null, -1))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                            _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "h5 mb-3" }, [
                                _createElementVNode("i", { class: "fas fa-map-marker-alt me-2" }),
                                _createTextVNode("Ubicación ")
                            ], -1)),
                            _createElementVNode("p", _hoisted_23, [
                                _createElementVNode("strong", null, _toDisplayString(eventLocation.value), 1)
                            ]),
                            _createElementVNode("p", _hoisted_24, [
                                _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-map-pin me-1" }, null, -1)),
                                _createTextVNode(_toDisplayString(eventAddress.value), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                            _cache[24] || (_cache[24] = _createElementVNode("h3", { class: "h5 mb-3" }, [
                                _createElementVNode("i", { class: "fas fa-info-circle me-2" }),
                                _createTextVNode("Información Adicional ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_26, [
                                _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fas fa-tag me-2" }, null, -1)),
                                _createElementVNode("span", null, [
                                    _cache[16] || (_cache[16] = _createElementVNode("strong", null, "Tipo:", -1)),
                                    _createTextVNode(" " + _toDisplayString(eventType.value), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                                _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fas fa-dollar-sign me-2" }, null, -1)),
                                _createElementVNode("span", null, [
                                    _cache[18] || (_cache[18] = _createElementVNode("strong", null, "Precio:", -1)),
                                    _createTextVNode(" " + _toDisplayString(eventPrice.value), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                                _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fas fa-phone me-2" }, null, -1)),
                                _createElementVNode("span", null, [
                                    _cache[20] || (_cache[20] = _createElementVNode("strong", null, "Contacto:", -1)),
                                    _createTextVNode(" " + _toDisplayString(eventContact.value), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                                _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fas fa-clock me-2" }, null, -1)),
                                _createElementVNode("span", null, [
                                    _cache[22] || (_cache[22] = _createElementVNode("strong", null, "Horarios:", -1)),
                                    _createTextVNode(" " + _toDisplayString(eventHours.value), 1)
                                ])
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
